var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "share-link-modal",
        title: "Share a link",
        size: "lg",
        "hide-footer": "",
      },
    },
    [
      _c(
        "b-form-group",
        [
          _c(
            "b-input-group",
            [
              _c("b-form-input", {
                ref: "share",
                attrs: { value: _vm.shareLink },
              }),
              _vm._v(" "),
              _c(
                "b-input-group-append",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        id: "copy-to-clipboard",
                        size: "sm",
                        title: "Click to copy",
                        variant: "secondary",
                      },
                      on: { click: _vm.copyToClipboard },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-clipboard",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tooltip",
                    {
                      ref: "tooltip",
                      attrs: { target: "copy-to-clipboard", triggers: "none" },
                    },
                    [_vm._v("\n          Copied\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }